<template>
    <v-container>
        <v-snackbar v-model="alert" timeout="5000" :color="alertType">
            {{ alertContent }}
        </v-snackbar>
        <v-card style="margin-bottom:10px">
            <v-card-title>
                {{$t('faxSystem')}}
            </v-card-title>
        </v-card>
        <v-card>
            <v-card-text width="800">
                <v-text-field v-model="phone" :label="$t('faxTargetNumber')"
                    :placeholder="$t('faxTargetNotice')">
                </v-text-field>
                <v-text-field v-model="callerId" :label="$t('callerId')">
                </v-text-field>
                <v-file-input @change="updatePreview" v-model="pdfFile" :label="$t('fileToSent')" clearable accept=".pdf" placeholder="ניתן לעלות קבצי PDF בלבד"></v-file-input>
                <v-subheader>{{$t('preview')}}:</v-subheader>
                <embed :src="previewURL" width="100%">
                <v-alert dense outlined type="info">{{$t('faxSentNotice')}}</v-alert>
                <p v-show="uploadStatus" style="margin-bottom: 0px; margin-right: 95%">{{ uploadProgress }}%</p>
                <v-progress-linear v-show="uploadStatus" color="primary" :value="uploadProgress"></v-progress-linear>
                <v-btn class="mt-3" color="primary" @click="sendFax">{{$t('sendFax')}}</v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        alert: false,
        alertType: '',
        alertContent: '',
        phone: '',
        callerId: '',
        pdfFile: null,
        previewURL: '',
        uploadStatus: false,
        uploadProgress: 0,
    }),
    methods: {
        loadData () {
            (async () => {
                const body = { token: sessionStorage.token };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetCustomerData`, body);
                this.callerId = response.data.mainDid;
            })();
        },
        sendFax() {
            (async () => {
                this.uploadStatus = true;

                let formData = new FormData();
                formData.append("token", sessionStorage.token);
                formData.append("phone", this.phone);
                formData.append("pdfFile", "UPLOAD");
                formData.append("fileToUpload", this.pdfFile);
                formData.append("callerId", this.callerId);
                let config = { onUploadProgress: function( progressEvent ) { this.uploadProgress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );}.bind(this) };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/SendFax`, formData, config, { headers: { "Content-Type": "multipart/form-data", } });
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('faxSentSuccess')
                    this.uploadStatus = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('faxSentError')
                    this.uploadStatus = false;
                }
            })();
        },
        updatePreview(file = this.file) {
            this.previewURL = URL.createObjectURL(file)
        }
    },
    beforeMount() {
        this.loadData();
    }
}
</script>